import { PassportTabsEnum } from '../enums/PassportTabsEnum';

export const erknmPreviewHeaderTabs: Array<{ name: PassportTabsEnum; text: string }> = [
  {
    name: PassportTabsEnum.COMMON,
    text: 'Общая информация',
  },
  {
    name: PassportTabsEnum.CONTROL,
    text: 'Информация об органе контроля',
  },
  {
    name: PassportTabsEnum.PROSECUTOR,
    text: 'Информация об органе прокуратуры',
  },
  {
    name: PassportTabsEnum.FACE,
    text: 'Сведения о контролируемом лице',
  },
  {
    name: PassportTabsEnum.VIOLATION,
    text: 'Список выявленных нарушений',
  },
];
